import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { EeljProps } from "./EeljInfo";
import { UserContext } from "../../providers/UserProvider";

export const FAQ = () => {
  return (
    <div className="bg-white">
      <div className="mx-auto max-w-7xl px-6 py-24 sm:pt-32 lg:px-8 lg:py-40">
        <div className="lg:grid lg:grid-cols-12 lg:gap-8">
          <div className="lg:col-span-5">
            <h2 className="text-2xl font-bold leading-10 tracking-tight text-gray-900 italic">
              Түгээмэл асуулт хариулт
            </h2>
          </div>
          <div className="mt-10 lg:col-span-7 lg:mt-0">
            <dl className="space-y-10">
              <div>
                <dt className="text-base font-semibold leading-7 text-gray-900">
                  Автобусны аюулгүй байдлын дүрэм юу вэ?
                </dt>
                <dd className="mt-2 text-base leading-7 text-gray-600">
                  Суудлын бүсийг заавал зүүх Автобус хөдлөх үед босохгүй байх
                  Автобусанд юм идэх хориотой Суудал дээрээс эргэж харах, босож
                  зогсох, үсрэхгүй байх Бүлгийн удирдагчийн заавар зөвлөгөөг
                  биелүүлэх
                </dd>
              </div>
              <div>
                <dt className="text-base font-semibold leading-7 text-gray-900">
                  Хоцорсон үед яах вэ?
                </dt>
                <dd className="mt-2 text-base leading-7 text-gray-600">
                  Ээлжийн цуваанаас хоцорсон тохиолдолд эцэг эхчүүд болон асран
                  хамгаалагч нь цогцолборын байранд хүргэж өгөх асуудлыг бүрэн
                  хариуцна. Амрагч хүүхдийн овог нэр, нас, хүйс, холбоо барих
                  дугаар, цогцолборт ирэх цаг зэргийг тухайн өдрийн 12.00 цагаас
                  өмнө 75056010 дугаарт залган тэмдэглүүлнэ. Заасан хугацаанд
                  дээрх мэдээллийг ирүүлээгүй тохиолдолд бүлэг хувиарлалтаас
                  хоцрох тул хариуцлагатай хандахыг хүсч байна.
                </dd>
              </div>
              <div>
                <dt className="text-base font-semibold leading-7 text-gray-900">
                  Эргэлт хийх бол яах вэ?
                </dt>
                <dd className="mt-2 text-base leading-7 text-gray-600">
                  Зуслан нь хүүхдийн бие даах чадвар нэмэгдүүлэх зорилготой орчин
                  учраас “ЭРГЭЛТ” үйл ажиллагааг зохион байгуулахгүйг анхаарна уу.
                </dd>
              </div>
              <div>
                <dt className="text-base font-semibold leading-7 text-gray-900">
                  Бүлгийн мэдээлэл хэрхэн авах вэ?
                </dt>
                <dd className="mt-2 text-base leading-7 text-gray-600">
                  Та хүүхдээ аль бүлэгт орсон, бүлгийн удирдагчтай холбогдох
                  тохиолдолд тухайн ээлж эхэлсэн өдрийн 14,00 цагаас хойш 75056010
                  тоот утсаар хүүхдийнхээ овог, нэр, сургуулийг хэлж ямар бүлэгт
                  хувиарлагдсаныг мэдэж болно..
                </dd>
              </div>
            </dl>
          </div>
        </div>
      </div>
    </div>
  )
};

export const EeljFull = (props: EeljProps) => {
  const {userBio} = useContext(UserContext);
  const {id, name, active, title, description, thumb, price, ITtrainingPrice, start_date, end_date, ageGroup, orderStartDate, orderEndDate} = props;
  const [curDate, setCurDate] = useState(new Date());

  const getDateString = (date: string | Date) => {
    return new Date(date).toISOString().split('T')[0].replaceAll('-', '.');
  }

  const countdownString = useMemo(() => {
    const diff = new Date(orderStartDate).valueOf() - curDate.valueOf();

    const formatDuration = (millis: number) => {
      let date = new Date(millis);
      let parts = [];
  
      if (date.getUTCFullYear() > 1970) {
          let years = date.getUTCFullYear() - 1970;
          parts.push(years, 'жил');
      }
      if (date.getUTCMonth() > 0) { // months start at zero
          let months = date.getUTCMonth();
          parts.push(months, 'сар');
      }
      if (date.getUTCDate() > 1) {
          let days = date.getUTCDate() - 1;
          parts.push(days, 'өдөр');
      }

      parts.push(date.toISOString().substring(11, 19));
      return parts.join(' ');
    }
  
    return formatDuration(diff);
  }, [curDate, orderStartDate]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurDate(new Date());
    }, 1000);

    return () => {
      clearInterval(interval);
    }
  }, []);


  return (
    <div className="bg-white">
      <div className="mx-auto max-w-2xl px-4 py-16 sm:px-6 sm:py-24 lg:max-w-7xl lg:px-8">
        <div className="lg:grid lg:grid-cols-2 lg:items-start lg:gap-x-8 mt-12">
          <div className="flex flex-col-reverse">
            <div className="aspect-h-1 aspect-w-1 w-full">
              <div
                id="headlessui-tabs-panel-:rf:"
                role="tabpanel"
                tabIndex={0}
                data-headlessui-state="selected"
              >
                <img
                  src={thumb}
                  alt=""
                  className="h-full w-full object-cover object-center sm:rounded-lg"
                />
              </div>
            </div>
          </div>
          <div className="mt-10 px-4 sm:mt-16 sm:px-0 lg:mt-0">
            <h1 className="text-3xl font-bold tracking-tight text-gray-900">
              {title}
            </h1>
            <div className="mt-3">
              <h2 className="sr-only">Product information</h2>
              <p className="text-3xl tracking-tight text-gray-900">{price + ITtrainingPrice} ₮</p>
            </div>
            <div className="mt-6">
              <h3 className="sr-only">Description</h3>
              <div className="space-y-6 text-base text-gray-700">
                {description}
              </div>
            </div>
            <div className="flex justify-around mt-8">
              <div>
                <p className="text-center">Хугацаа</p>{" "}
                <p>{getDateString(start_date)}-{getDateString(end_date)}</p>
              </div>
              <div>
                <p className="text-center">Насны ангилал</p>
                <p className="text-center">{ageGroup}</p>
              </div>
            </div>
            <div className="mt-6">
              { new Date(orderEndDate) > curDate ?
                curDate > new Date(orderStartDate) ?
                  userBio ?
                    <Link to={`/payment/${id}`} className="flex flex-1 items-center justify-center rounded-full border border-transparent bg-[#0EB0EC] px-3 py-2 text-base font-medium text-white sm:w-full">
                      Худалдаж авах
                    </Link>
                    :
                    <Link to={`/login`} className="flex flex-1 items-center justify-center rounded-full border border-transparent bg-[#0EB0EC] px-3 py-2 text-base font-medium text-white sm:w-full">
                      Нэвтрэх
                    </Link>
                  :
                  <div className="flex flex-1 items-center justify-center rounded-full border border-transparent bg-[#0EB0EC] px-3 py-2 text-base font-medium text-white sm:w-full">
                    Захиалга эхлэхэд {countdownString} үлдлээ
                  </div>
                :
                <div className="flex flex-1 items-center justify-center rounded-full border border-transparent bg-gray-300 px-3 py-2 text-base font-medium text-white sm:w-full">
                  Захиалга дууссан
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export const EeljDetail = () => {
  const {id} = useParams();
  const {eeljuud} = useContext(UserContext);

  const eelj = useMemo(() => {
    return [...eeljuud.activeEelj, ...eeljuud.eelj].find(e => e.id === id);
  }, [id, eeljuud]);

  return (
    <>
      {eelj &&
        <>
          <EeljFull {...eelj}/>
          <FAQ/>
        </>
      }
    </>
  )
}

export default EeljDetail;